(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var thumb = event.target.closest('[data-tenzonn-thumb]');
    var qtyMinus = event.target.closest('[data-tenzonn-qty-minus]');
    var qtyPlus = event.target.closest('[data-tenzonn-qty-plus]');

    if (qtyMinus || qtyPlus) {
      var control = event.target.closest('[data-tenzonn-qty]');
      if (!control) return;
      var input = control.querySelector('input[name="quantity"]');
      if (!input) return;
      var current = parseInt(input.value || '1', 10);
      var next = qtyPlus ? current + 1 : Math.max(1, current - 1);
      input.value = next;
      document.querySelectorAll('[data-tenzonn-qty] input[name="quantity"]').forEach(function(item) {
        item.value = next;
      });
      return;
    }

    if (!thumb) return;

    var media = thumb.closest('.tenzonn-pdp__media');
    if (!media) return;

    var index = thumb.getAttribute('data-tenzonn-thumb');
    var thumbs = media.querySelectorAll('[data-tenzonn-thumb]');
    var photos = media.querySelectorAll('[data-tenzonn-photo]');

    thumbs.forEach(function(item) {
      var active = item === thumb;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-current', active ? 'true' : 'false');
    });

    photos.forEach(function(photo) {
      var active = photo.getAttribute('data-tenzonn-photo') === index;
      photo.classList.toggle('is-active', active);
      photo.hidden = !active;
    });
  });

  document.addEventListener('input', function(event) {
    if (!event.target.matches('[data-tenzonn-qty] input[name="quantity"]')) return;
    var value = Math.max(1, parseInt(event.target.value || '1', 10));
    document.querySelectorAll('[data-tenzonn-qty] input[name="quantity"]').forEach(function(item) {
      item.value = value;
    });
  });

  var stickyCart = document.querySelector('[data-tenzonn-sticky-cart]');
  var productPanel = document.getElementById('product-main-info');
  if (stickyCart && productPanel) {
    var toggleStickyCart = function() {
      var rect = productPanel.getBoundingClientRect();
      stickyCart.classList.toggle('is-visible', rect.bottom < 80);
    };
    toggleStickyCart();
    window.addEventListener('scroll', toggleStickyCart, { passive: true });
    window.addEventListener('resize', toggleStickyCart);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
